export default "__VITE_ASSET__qGqG60iE__"